export default "__VITE_ASSET__CvOAWjbe__"